import { Store } from 'src/store/index';

const getIsMobile = (store: Store) => store.app.isMobile;

export default getIsMobile;
